// extracted by mini-css-extract-plugin
export default {"headerStyles":"components-Header-themes-BGH-stylesHeader__headerStyles--ScuFl","bno":"components-Header-themes-BGH-stylesHeader__bno--lN015"};